/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ArchitectureInputs */

const en_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const es_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura`)
};

const fr_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const de_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektur`)
};

const ja_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建築`)
};

const zh_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建筑摄影`)
};

const ar_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير معماري`)
};

const id_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arsitektur`)
};

const it_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architettura`)
};

const ru_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архитектура`)
};

const pt_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura`)
};

const ko_val_architecture = /** @type {(inputs: Val_ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`건축`)
};

/**
* | output |
* | --- |
* | "Architecture" |
*
* @param {Val_ArchitectureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_architecture = /** @type {((inputs?: Val_ArchitectureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ArchitectureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_architecture(inputs)
	if (locale === "es") return es_val_architecture(inputs)
	if (locale === "fr") return fr_val_architecture(inputs)
	if (locale === "de") return de_val_architecture(inputs)
	if (locale === "ja") return ja_val_architecture(inputs)
	if (locale === "zh") return zh_val_architecture(inputs)
	if (locale === "ar") return ar_val_architecture(inputs)
	if (locale === "id") return id_val_architecture(inputs)
	if (locale === "it") return it_val_architecture(inputs)
	if (locale === "ru") return ru_val_architecture(inputs)
	if (locale === "pt") return pt_val_architecture(inputs)
	return ko_val_architecture(inputs)
});